export default __webpack_public_path__ + "static/media/ginni_mansberg.6c67b9ab.jpg";